import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { LakehouseTableDataset } from 'shell-models-lib';
import { TabularCopySource } from './tabular-type.copysource';
import { IAttribute } from '../../base/annotation';
import { partitionOptionConst } from 'app/registries/consts/metadata-consts';

@Metamodel.model({
    name: adfModelTypeMap.lakehouseTable.copySourceType,
    display: [],
    tags: { datasetModel: [Metamodel.modelFor(LakehouseTableDataset)] }
})
export class LakehouseTableCopySource extends TabularCopySource {
    public static readonly TIMESTAMP: IAttribute;
    public static readonly VERSION: IAttribute;
    public static readonly QUERY_TIMEOUT: IAttribute;
    public static readonly PARTITION_OPTION: IAttribute;
    public static readonly PARTITION_COLUMN_NAME: IAttribute;
    public static readonly PARTITION_UPPER_BOUND: IAttribute;
    public static readonly PARTITION_LOWER_BOUND: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'TIMESTAMP',
        accepts: ['String'],
        display: stringResources.DataFlowColumnType_Timestamp
    })
    public timestampAsOf?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'VERSION',
        accepts: ['Int'],
        display: stringResources.VersionLabel
    })
    public versionAsOf?: number;
    
    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY_TIMEOUT',
        display: stringResources.ModelName_Source_QueryTimeout_Min,
        accepts: ['String'],
        constraint: {
            minimum: 1,
            maximum: 1440
        }
    })
    public queryTimeout?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_OPTION',
        display: stringResources.ModelName_Partition_Option,
        defaultValue: partitionOptionConst.none
    })
    public partitionOption?: string = partitionOptionConst.none;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_COLUMN_NAME',
        display: stringResources.ModelName_Partition_ColumnName
    })
    public partitionColumnName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_UPPER_BOUND',
        display: stringResources.ModelName_Partition_UpperBound
    })
    public partitionUpperBound?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_LOWER_BOUND',
        display: stringResources.ModelName_Partition_LowerBound
    })
    public partitionLowerBound?: string;
}
